module.exports = __webpack_public_path__ + "img/ContratoSVNacional2.eda9db79.jpg";